var AdaptiveImage = require("../../../node_modules/react-native-web-image-loader/lib/modules/adaptiveImage.js").default;

module.exports = new AdaptiveImage({
    uri: __webpack_public_path__ + "static/media/kine_patient.0fe07ce4.png","uri@3x": __webpack_public_path__ + "static/media/kine_patient.c84feae5.png","uri@2x": __webpack_public_path__ + "static/media/kine_patient.e0c220e9.png",
    width: 24,
    height: 24
});